module.exports = __webpack_public_path__ + "img/DK67051815.7459ab6f.png";